import React, { Component } from 'react';
import axios from 'axios';
import City from './City';
import CityList from './CityList';
import Footer from './Footer';

// <Route path='/cities/:slug' component={City}/>

class Cities extends Component {
  render() {
    let city = this.props.match.params.slug;
    let selectedCity =
      city &&
      this.state.cities.find(c => {
        return c.slug === city;
      });
    city = city ? (
      <City slug={city} city={selectedCity} />
    ) : (
      <div className="staticWidth">
        <div className="staticHeader">
          {this.state.page && this.state.page.title}
        </div>
        <div
          className=" pt1 mb8 staticBody faded"
          dangerouslySetInnerHTML={{
            __html: this.state.page && this.state.page.body,
          }}
        />
      </div>
    );
    return (
      <div className="staticParent">
        {city}
        <div className="container">
          <CityList cities={this.state.cities} />
        </div>
        <Footer />
      </div>
    );
  }

  constructor() {
    super();
    this.state = {
      page: {},
      cities: [],
    };
    this.getPage();
  }

  componentWillReceiveProps(nextProps) {
    document.getElementsByClassName('staticParent')[0].parentNode.scrollTop = 0;
  }

  getPage() {
    axios
      .get('/page/cities')
      .then(p => {
        this.setState({ page: p.data });
      })
      .catch(error => {
        console.log(error);
      });
    axios
      .get('/city')
      .then(p => {
        this.setState({ cities: p.data });
      })
      .catch(error => {
        console.log(error);
      });
  }
}

export default Cities;



// WEBPACK FOOTER //
// ./src/components/Cities.jsx